import { render } from "./TosView.vue?vue&type=template&id=73da6772&scoped=true"
import script from "./TosView.vue?vue&type=script&lang=js"
export * from "./TosView.vue?vue&type=script&lang=js"

import "./TosView.vue?vue&type=style&index=0&id=73da6772&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73da6772"]])

export default __exports__